document.addEventListener("DOMContentLoaded", () => {

    const items = document.querySelectorAll(".lw-reveal");

    if (!("IntersectionObserver" in window)) {

        items.forEach(item => item.classList.add("is-visible"));

        return;

    }

    const observer = new IntersectionObserver(entries => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add("is-visible");

            observer.unobserve(entry.target);

        });

    },{

        threshold:.18

    });

    items.forEach(item => observer.observe(item));

});